import React, { useEffect } from 'react';

const GTranslateDropdown = () => {
  useEffect(() => {
    // Define GTranslate settings
    window.gtranslateSettings = {
      default_language: 'en',
      languages: ['en','de', 'ar', 'pl'],
      wrapper_selector: '.gtranslate_wrapper'
    };

    // Create script tag for dropdown widget
    const script = document.createElement('script');
    script.src = 'https://cdn.gtranslate.net/widgets/latest/dropdown.js';
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup on unmount
      document.body.removeChild(script);
    };
  }, []);

  return <div className="gtranslate_wrapper"/>;
};

export default GTranslateDropdown;
